const getDeadlineToSend = (deadline: string): string => {
  let finalDeadline: string;
  const deadlineAlreadyHasTimePart = deadline.includes('T');

  if (deadlineAlreadyHasTimePart) {
    finalDeadline = deadline;
  } else {
    finalDeadline = new Date(`${deadline}T23:59`).toISOString();
  }
  return finalDeadline;
};

export default getDeadlineToSend;
